export const API_ENDPOINTS = {
  CONSUMER_PORTAL: {
    AUTH: {
      LOGIN: '/consumer-portal/login',
      ME: '/consumer-portal/me',
    },
    DASHBOARD: '/consumer-portal/dashboard',
    GAMES: '/consumer-portal/games',
    USERS: '/consumer-portal/users',
    GET_USER_DETAILS: (id: string | number) => `/consumer-portal/users/${id}`,
    BATTLES: '/consumer-portal/battles',
    GET_BATTLE_DETAILS: (id: string | number) => `/consumer-portal/battles/${id}`,
    GET_BATTLE_ROUND: (battleId: string | number, roundId: string | number) =>
      `/consumer-portal/battles/${battleId}/rounds/${roundId}`,
    TRANSACTIONS: '/consumer-portal/transactions',
    PRIVATE_TABLES: '/consumer-portal/private-tables',
  },
  ADMIN: {
    AUTH: {
      LOGIN: '/admin/login',
      ME: '/admin/me',
    },
    DASHBOARD: {
      GET_STATS: '/admin/dashboard',
    },
    GAMES: {
      GET_ALL: '/admin/games',
      CREATE: '/admin/games',
      UPDATE: (id: string | number) => `/admin/games/${id}`,
      DELETE: (id: string | number) => `/admin/games/${id}`,
      GET_CONFIG: (id: string | number) => `/admin/games/${id}/config`,
      UPDATE_CONFIG: (id: string | number) => `/admin/games/${id}/config`,
    },
    CONSUMERS: {
      GET_ALL: '/admin/consumers',
      GET_DETAILS: (id: string | number) => `/admin/consumers/${id}`,
      CREATE: '/admin/consumers',
      UPDATE: (id: string | number) => `/admin/consumers/${id}`,
      DELETE: (id: string | number) => `/admin/consumers/${id}`,
      GET_GAMES: (id: string | number) => `/admin/consumers/${id}/games`,
      SET_GAMES: (id: string | number) => `/admin/consumers/${id}/games`,
    },
    INTEGRATION_LOGS: {
      GROUPS: '/admin/integration-logs/groups',
      RETRY_CONFIG: '/admin/integration-logs/retry-config',
      GROUP_DETAIL: (retryGroupId: string) => `/admin/integration-logs/groups/${retryGroupId}`,
      MANUAL_RETRY: (retryGroupId: string) => `/admin/integration-logs/groups/${retryGroupId}/retry`,
    },
    VARIANTS: {
      GET_ALL: '/admin/variants',
      TOGGLE_STATUS: '/admin/variants/toggle',
      TOGGLE_PRIVATE_TABLE: '/admin/variants/private-table/toggle',
      UPDATE_ASSETS: '/admin/variants/assets',
    },
    CONFIG: {
      /** @deprecated use GAMES.GET_CONFIG(gameId) */
      GET: '/admin/config',
      UPDATE: '/admin/config',
    },
    // Game Configuration Module — gameplay currency types
    CURRENCIES: {
      GET_ALL: '/admin/currencies',
      CREATE: '/admin/currencies',
      UPDATE: (id: string | number) => `/admin/currencies/${id}`,
      DELETE: (id: string | number) => `/admin/currencies/${id}`,
    },
    PLAYERS: {
      GET_ALL: '/admin/players',
      GET_DETAILS: (id: string | number) => `/admin/players/${id}`,
      UPDATE_STATUS: (id: string | number) => `/admin/players/${id}/status`,
      BAN_HARDWARE: (id: string | number) => `/admin/players/${id}/ban-hardware`,
      SET_PREFERRED_CURRENCY: (id: string | number) => `/admin/players/${id}/preferred-currency`,
    },
    // Table Management Module — selectable Teen Patti game variants (DB-driven)
    TABLE_VARIANTS: {
      GET_ALL: '/admin/table-variants',
    },
    TABLES: {
      GET_ALL: '/admin/tables',
      CREATE: '/admin/tables',
      UPDATE: (id: string | number) => `/admin/tables/${id}`,
      DELETE: (id: string | number) => `/admin/tables/${id}`,
    },
    WALLET: {
      GET_LEDGER: '/admin/wallet/ledger',
      PROCESS_TRANSACTION: '/admin/wallet/process',
      ABNORMAL_SHIFTS: '/admin/wallet/abnormal-shifts',
    },
    // Game Monitoring Module — read-only battle / round / ledger inspection
    BATTLES: {
      GET_ALL: '/admin/battles',
      GET_DETAILS: (id: string | number) => `/admin/battles/${id}`,
      GET_ROUND: (battleId: string | number, roundId: string | number) =>
        `/admin/battles/${battleId}/rounds/${roundId}`,
    },
    GAME_LEDGER: {
      GET_ALL: '/admin/game-ledger',
    },
    REPORTS: {
      GET_FINANCIALS: '/admin/reports/financials',
      GET_RETENTION: '/admin/reports/retention',
    },
    // Private battles are listed on the Battles endpoint (BATTLES.GET_ALL?type=2)
    // and reuse the shared Battle detail page (BATTLES.GET_DETAILS).
    PRIVATE_TABLES: {
      GET_ALL: '/admin/private-tables',
      GET_DETAILS: (id: string | number) => `/admin/private-tables/${id}`,
      PURGE: (id: string | number) => `/admin/private-tables/${id}/purge`,
      TOGGLE_STATUS: (id: string | number) => `/admin/private-tables/${id}/toggle-status`,
      GET_SESSION: (id: string | number) => `/admin/private-tables/${id}/session`,
    },
    // Role & Permission Module — available module catalogue
    MODULES: {
      GET_ALL: '/admin/modules',
    },
    // Role & Permission Module — RBAC role definitions
    ROLES: {
      GET_ALL: '/admin/roles',
      CREATE: '/admin/roles',
      UPDATE_PERMISSIONS: (id: string | number) => `/admin/roles/${id}/permissions`,
      DELETE: (id: string | number) => `/admin/roles/${id}`,
    },
    // Role & Permission Module — admin/staff accounts
    ADMIN_USERS: {
      GET_ALL: '/admin/admin-users',
      CREATE: '/admin/admin-users',
      UPDATE: (id: string | number) => `/admin/admin-users/${id}`,
      UPDATE_STATUS: (id: string | number) => `/admin/admin-users/${id}/status`,
      DELETE: (id: string | number) => `/admin/admin-users/${id}`,
    },
  }
};
